import React, { useEffect, useRef, useState } from 'react';
import './HomePage.css'
import { BrowserRouter, Routes, Route, redirect, Navigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog'
import CloseMenuListIcon from '../../assets/closeMenuListIcon.png'
/* import Login from '../Auth/Login';
import SignUp from '../Auth/SignUp'; */
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Mic from '../../assets/mic.png'
import Attachment from '../../assets/attachment.png'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import AuthLoader from '../../assets/authLoader.png'
import PlayAudio from '../../assets/playbutton.png'
import DownloadAudio from '../../assets/downloading.png'
import { setTimeout } from 'timers';


interface IProps {
  aiDialog: any
  setAIDialog: any
  userId: any
  getProjectWithGroup: any
  projectData: any
  userData: any
  colorSchemes: any
  isDark: any
  mobileView: any
  sendSocketMessage: any
  isLightMode: any
}


function AIDialog(
  {
    aiDialog,
    setAIDialog,
    userId,
    getProjectWithGroup,
    projectData,
    userData,
    colorSchemes,
    isDark,
    mobileView,
    sendSocketMessage,
    isLightMode
  }: IProps
) {
  enum MODEL {
    GPT3_TURBO = 'gpt-3.5-turbo',
    GPT3 = 'gpt-3',
    TTS1 = 'tts-1',
  }
  interface OpenAIFetchProps {
    choices: [
      {
        message: {
          content: string;
          role: string;
        }
        index: number;
      }
    ];
    created: number;
    id: string;
    model: string;
    object: string;
  }
  const SPEECH_LANGUAGE = 'en-US';
  const [newListType, setNewListType] = useState(false);
  const [selectFolder, setSelectFolder] = useState(false);
  const [listType, setListType] = useState("Task List");
  // const [selectedFolderItem, setSelectedFolderItem]:any = useState({});
  const [showAddNewFolderDiv, setShowAddNewFolderDiv] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const mySelectDiv: any = useRef(0);

  const [transcription, setTranscription] = useState('');
  const [isListening, setIsListening] = useState(false);
  const { transcript, resetTranscript, listening } = useSpeechRecognition();
  const [isSupported, setIsSupported] = useState(false);
  const [data, setData] = useState('');

  const handleListen = () => {
    SpeechRecognition.startListening({ language: SPEECH_LANGUAGE/* , continuous: true */ });
    setTranscription(transcript);
  }

  const handleStopListen = () => {
    setTranscription(transcript);
    console.log("transcript", transcript)
    setData('')
    resetTranscript();
    SpeechRecognition.stopListening();
  }

  const toggleListen = () => {
    setIsListening(!isListening);

    if (!isListening) {
      handleListen();
    } else {
      handleStopListen();
      //fetchGPT().then(handleTextToSpeech);
    }
  }
  const [formData, setFormData] = useState(null);
  const audioInputRef: any = useRef()
  const selectMP3File = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      const data = new FormData();
      //data.append("file", file);
      data.append("model", "whisper-1");
      data.append("language", "en");
      //setFormData(data);
      console.log("formData", file)
      audioInputRef.current.value = "";
      // check if the size is less than 25MB
      if (file.size > 25 * 1024 * 1024) {
        alert("Please upload an audio file less than 25MB");
        return;
      }
    }
  };

  const [convertedText, setConvertedText] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [aiType, setAiType] = useState('speachtotext');
  const [textToSpechInputValue, setTextToSpechInputValue] = useState('');


  const sendAudio = async () => {
    setLoading(true);
    const res = await fetch("https://api.openai.com/v1/audio/transcriptions", {
      headers: {
        Authorization: `Bearer `,
      },
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    setLoading(false);
    setData(data.text);

  };

  let audioCtx = new AudioContext();
  let source = new AudioBufferSourceNode(audioCtx);

  
  const fetchGPTSpeachToText = async () => {


    try {


      /*  return {
         "id": "chatcmpl-8NaxE2zjEHEnasDLya36JVG8FiSxK",
         "object": "chat.completion",
         "created": 1700634288,
         "model": "gpt-3.5-turbo-0613",
         "choices": [
           {
             "index": 0,
             "message": {
               "role": "assistant",
               "content": "India, officially known as the Republic of India, is a diverse and culturally rich country located in South Asia. It is the seventh-largest country by land area and the second-most populous country in the world, with over 1.3 billion people. India shares its borders with Pakistan to the northwest, China and Nepal to the north, Bhutan to the northeast, and Bangladesh and Myanmar to the east. It is also surrounded by the Indian Ocean to the south.\n\nIndia has a long and complex history dating back thousands of years. It is known for being one of the oldest civilizations in the world, with evidence of human settlements in the region dating back to the Indus Valley Civilization around 2500 BCE. Throughout its history, India has seen the rise and fall of various dynasties and empires, including the Maurya, Gupta, Mughal, and British Empires.\n\nAfter a long struggle for independence, India finally gained its freedom from British colonial rule on August 15, 1947. This day is celebrated annually as India's Independence Day. Following independence, the country adopted a democratic system of government and became a republic on January 26, 1950.\n\nIndia is known for its diverse culture, languages, religions, and traditions. It is home to several major religions, including Hinduism, Islam, Christianity, Sikhism, Buddhism, and Jainism. The country is often referred to as the birthplace of Hinduism, Buddhism, Jainism, and Sikhism. The Indian Constitution guarantees religious freedom to all its citizens.\n\nThe Indian economy is one of the fastest-growing in the world, and it is classified as a mixed economy. It has a strong service sector, including Information Technology (IT), telecommunications, banking, finance, and tourism. Agriculture also plays a significant role in the country's economy, employing a large portion of the population.\n\nIndia is famous for its diverse cuisine, which varies greatly from region to region. Each state and even each city has its own specialty dishes. Indian cuisine is known for its rich flavors, spices, and use of a wide variety of vegetables, grains, and lentils.\n\nThe country is also renowned for its vibrant festivals, such as Diwali (Festival of Lights), Holi (Festival of Colors), Eid, Christmas, and many more. These festivals reflect the cultural diversity and religious harmony of the country.\n\nIndia is home to several UNESCO World Heritage Sites, including the Taj Mahal, Qutub Minar, Red Fort, Jaipur's City Palace, and the temples of Khajuraho. It also has a rich natural heritage, with diverse ecosystems ranging from the Himalayas in the north to the backwaters of Kerala in the south.\n\nHowever, India also faces various challenges, including poverty, illiteracy, healthcare issues, corruption, and environmental problems. The government is actively working towards addressing these issues and implementing social welfare programs to uplift the marginalized sections of society.\n\nOverall, India is a country of immense beauty, history, and cultural diversity. It has made significant contributions to the world in various fields, including science, technology, art, literature, and philosophy."
             },
             "finish_reason": "stop"
           }
         ],
         "usage": {
           "prompt_tokens": 12,
           "completion_tokens": 636,
           "total_tokens": 648
         }
       } */





      // https://api.openai.com/v1/chat/completions
      // https://api.openai.com/v1/completions
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer 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`,
        },
        body: JSON.stringify({
          model: MODEL.GPT3_TURBO,
          messages: [{ role: 'user', content: transcription }],
          temperature: 0.7,
        }),
      });
      setLoading(false);
      return response.json();

    } catch (error) {
      console.log(error);
    }
  }

  const fetchGPTTextSearch = async () => {


    try {


      /*  return {
         "id": "chatcmpl-8NaxE2zjEHEnasDLya36JVG8FiSxK",
         "object": "chat.completion",
         "created": 1700634288,
         "model": "gpt-3.5-turbo-0613",
         "choices": [
           {
             "index": 0,
             "message": {
               "role": "assistant",
               "content": "India, officially known as the Republic of India, is a diverse and culturally rich country located in South Asia. It is the seventh-largest country by land area and the second-most populous country in the world, with over 1.3 billion people. India shares its borders with Pakistan to the northwest, China and Nepal to the north, Bhutan to the northeast, and Bangladesh and Myanmar to the east. It is also surrounded by the Indian Ocean to the south.\n\nIndia has a long and complex history dating back thousands of years. It is known for being one of the oldest civilizations in the world, with evidence of human settlements in the region dating back to the Indus Valley Civilization around 2500 BCE. Throughout its history, India has seen the rise and fall of various dynasties and empires, including the Maurya, Gupta, Mughal, and British Empires.\n\nAfter a long struggle for independence, India finally gained its freedom from British colonial rule on August 15, 1947. This day is celebrated annually as India's Independence Day. Following independence, the country adopted a democratic system of government and became a republic on January 26, 1950.\n\nIndia is known for its diverse culture, languages, religions, and traditions. It is home to several major religions, including Hinduism, Islam, Christianity, Sikhism, Buddhism, and Jainism. The country is often referred to as the birthplace of Hinduism, Buddhism, Jainism, and Sikhism. The Indian Constitution guarantees religious freedom to all its citizens.\n\nThe Indian economy is one of the fastest-growing in the world, and it is classified as a mixed economy. It has a strong service sector, including Information Technology (IT), telecommunications, banking, finance, and tourism. Agriculture also plays a significant role in the country's economy, employing a large portion of the population.\n\nIndia is famous for its diverse cuisine, which varies greatly from region to region. Each state and even each city has its own specialty dishes. Indian cuisine is known for its rich flavors, spices, and use of a wide variety of vegetables, grains, and lentils.\n\nThe country is also renowned for its vibrant festivals, such as Diwali (Festival of Lights), Holi (Festival of Colors), Eid, Christmas, and many more. These festivals reflect the cultural diversity and religious harmony of the country.\n\nIndia is home to several UNESCO World Heritage Sites, including the Taj Mahal, Qutub Minar, Red Fort, Jaipur's City Palace, and the temples of Khajuraho. It also has a rich natural heritage, with diverse ecosystems ranging from the Himalayas in the north to the backwaters of Kerala in the south.\n\nHowever, India also faces various challenges, including poverty, illiteracy, healthcare issues, corruption, and environmental problems. The government is actively working towards addressing these issues and implementing social welfare programs to uplift the marginalized sections of society.\n\nOverall, India is a country of immense beauty, history, and cultural diversity. It has made significant contributions to the world in various fields, including science, technology, art, literature, and philosophy."
             },
             "finish_reason": "stop"
           }
         ],
         "usage": {
           "prompt_tokens": 12,
           "completion_tokens": 636,
           "total_tokens": 648
         }
       } */





      // https://api.openai.com/v1/chat/completions
      // https://api.openai.com/v1/completions
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer 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`,
        },
        body: JSON.stringify({
          model: MODEL.GPT3_TURBO,
          messages: [{ role: 'user', content: textToSpechInputValue }],
          temperature: 0.7,
        }),
      });
      setLoading(false);
      return response.json();

    } catch (error) {
      console.log(error);
    }
  }
  const handleSpeechToText = (data: OpenAIFetchProps) => {
    try {



      setData(data.choices[0].message.content)

      /* const utterance = new SpeechSynthesisUtterance(data.choices[0].message.content);

      utterance.lang = SPEECH_LANGUAGE;
      utterance.rate = 1;

      speechSynthesis.speak(utterance); */
    } catch (error) {
      console.log(error);
    }
  }




  /* const fetchGPTTextToSpeach = async () => {
  

    try {

    //return audioFileSource;
      const response = await fetch('https://api.openai.com/v1/audio/speech', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer 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`,
        },
        body: JSON.stringify({
          model: MODEL.TTS1,
          voice : "alloy",
          input : textToSpechInputValue
        }),
      });
      setLoading(false);
      return response.arrayBuffer();

    } catch (error) {
      console.log(error);
    }
  }

  const handleTextToSpeech = (buffer : any) => {
    try {
       // setAudioFileSource(buffer)
        return audioCtx.decodeAudioData(buffer)
    } catch (error) {
      console.log(error);
    }
  }
  const playAudio = (decodedData : any) => {
    try {
     
      source.buffer = decodedData;
      source.connect(audioCtx.destination);
    //  console.log('urlaaa',URL.createObjectURL(source))
     // source.start(0);
     // setAudioFileSource(source)
    } catch (error) {
      console.log(error);
    }
  } */



  const audioRef = React.useRef(new Audio());



  const textToSpeach1 = async () => {


    try {

      //return audioFileSource;
      fetch('https://api.openai.com/v1/audio/speech', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer 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`,
        },
        body: JSON.stringify({
          model: MODEL.TTS1,
          voice: "alloy",
          input: textToSpechInputValue
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.arrayBuffer();
        })
        .then((bufferdata) => {

          const bufferData = new Uint8Array(bufferdata);
          const blob = new Blob([bufferData], { type: "audio/wav" });
          console.log('blob', blob)

          const objectURL = URL.createObjectURL(blob);
          setaudioUrl(objectURL)
          setLoading(false);


          /*  const objectURL = URL.createObjectURL(blob);
           audioRef.current.src = objectURL;
          
          // audioRef.current.play();
           //console.log('url',objectURL)
   
           const a = document.createElement('a'); 
           a.style.display = 'none'; 
           a.href = objectURL; 
           a.download = 'audio_file.mp3'; // set the desired filename 
           document.body.appendChild(a); 
           a.click(); 
           document.body.removeChild(a);  */




          // setIsFetching(false);
        })

    } catch (error) {
      console.log('error', error);
    }




  }




  const [audioUrl, setaudioUrl] = useState('');

  const play = async () => {

    audioRef.current.src = audioUrl;

    audioRef.current.play();

  }
  const downlaod = async () => {
    const box = document.getElementById('audioDownloadDiv');
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = audioUrl;
    a.download = 'audio_file.mp3'; // set the desired filename 
    if(box!=null)
   { box.appendChild(a);
    //document.body.appendChild(a);
    a.click();
    //  document.body.removeChild(a);
}

  }









  useEffect(() => {
    setIsSupported(SpeechRecognition.browserSupportsSpeechRecognition());
  }, []);
  useEffect(() => {
    if (!listening) {
      setIsListening(false);
      handleStopListen()
    }
  }, [listening]);

  return (
    <div>
      <Dialog
        open={aiDialog}
        onClose={() => { setAIDialog(false); }}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <ClickAwayListener onClickAway={() => { setAIDialog(false); }}>
          <div className='switchDialogMainDivNew' style={{ textAlign: 'center', background: !mobileView ? colorSchemes.DrawerBackColor : mobileView && isLightMode ? colorSchemes.DrawerBackColor : colorSchemes.MiddlePaneBackground, maxHeight: "90vh" }}>

            <div style={{ width: "100%", display: "flex", alignItems: "center", padding: "20px 20px", background: !mobileView ? "rgba(233, 236, 244, 1)" : mobileView && isLightMode ? "rgba(233, 236, 244, 1)" : "rgba(23, 45, 70, 0.9)" }}>
              <div style={{ width: "70%", textAlign: "left" }}>
                <h4 style={{ color: !mobileView ? '#172D46' : mobileView && isLightMode ? '#172D46' : colorSchemes.FontColor/* colorSchemes.FontBlackColor */, margin: 0, fontSize: "20px", fontFamily: "ManRopeBold" }}>AI</h4></div>
              <div style={{ textAlign: 'end', width: "30%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <img style={{ width: 12, cursor: 'pointer' }} onClick={() => { setAIDialog(false); }} src={CloseMenuListIcon} alt='' />
              </div>

            </div>



            {/* <div style={{ width: "max-content", display: "flex", alignItems: "center", padding: "5px 20px", alignSelf: "center" }}>

              <div style={{ width: "70%", textAlign: "left", background: "rgb(48, 104, 200)", borderRadius: 5, cursor: 'pointer', opacity: aiType == "speachtotext" ? 1 : 0.5 }} onClick={() => { setAiType('speachtotext') }} >
                <p style={{ color: '#ffffff', margin: 0, fontSize: "15px", fontFamily: "ManRopeBold", padding: 10 }}>Speach To Text</p>
              </div>
              <div style={{ width: "70%", textAlign: "left", background: "rgb(48, 104, 200)", marginLeft: 10, borderRadius: 5, cursor: 'pointer', opacity: aiType == "texttospeach" ? 1 : 0.5 }} onClick={() => { SpeechRecognition.stopListening(); setAiType('texttospeach') }}>
                <p style={{ color: '#ffffff', margin: 0, fontSize: "15px", fontFamily: "ManRopeBold", padding: 10 }}>Text To Speach</p>
              </div>


            </div> */}



            {/* <div style={{ textAlign: 'end', width: '100%' }}>
              <img style={{ width: 16, cursor: 'pointer' }} onClick={() => { setAddNewListDialog(false); setListType("Task List"); setNewListType(false); setSelectFolder(false); setSelectedFolderItem({});setProjectsInputValue('') }} src={CloseMenuListIcon} alt='' />
            </div> */}
            <div className="manageAccountContainer" style={{ marginTop: 0 }}>
              {/* {!isSupported && aiType == "speachtotext" &&
                <p>Sorry, your browser does not support speech recognition.</p>
              } */}

              {/* <h4 style={{color:colorSchemes.FontBlackColor }}>Add List</h4> */}
              <div style={{ padding: "20px 20px 0px 20px", display: 'flex', width: "100%", alignItems: "center", justifyContent: "center" }}>

                {aiType == "texttospeach" &&

                  <div className='shareDialogInputAndIcon' style={{ minWidth: 'calc(100% - 60px)', borderColor: !mobileView ? 'rgba(16, 24, 40, 0.2)' : mobileView && isLightMode ? 'rgba(16, 24, 40, 0.2)' : colorSchemes.FontColor }}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 5, padding: mobileView ? '13px 10px' : '9px 7px', background: !mobileView ? '#fff' : mobileView && isLightMode ? '#fff' : colorSchemes.MiddlePaneBackground, borderRadius: "8px" }}>

                      <div style={{ position: "absolute", marginTop: "-61px", background: !mobileView ? '#fff' : mobileView && isLightMode ? '#fff' : colorSchemes.MiddlePaneBackground, padding: "0px 5px", fontSize: "14px", color: !mobileView ? "#828B94" : mobileView && isLightMode ? "#828B94" : colorSchemes.FontColor }}>Search</div>
                      <input
                        className='shareDialogInput'
                        style={{ background: !mobileView ? '#fff' : mobileView && isLightMode ? '#fff' : colorSchemes.MiddlePaneBackground, color: !mobileView ? '#172D46' : mobileView && isLightMode ? '#172D46' : colorSchemes.FontColor }}
                        type='text'
                        name='name'
                        placeholder='Type To search'
                        autoComplete='off'
                        onChange={(e) => {
                          setaudioUrl('')
                          setTextToSpechInputValue(e.target.value)

                        }}
                      />
                    </div>
                  </div>
                }
                {aiType == "speachtotext" &&
                  <div className='shareDialogInputAndIcon' style={{ minWidth: 'calc(100% - 60px)', borderColor: !mobileView ? 'rgba(16, 24, 40, 0.2)' : mobileView && isLightMode ? 'rgba(16, 24, 40, 0.2)' : colorSchemes.FontColor }}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 5, padding: mobileView ? '13px 10px' : '9px 7px', background: !mobileView ? '#fff' : mobileView && isLightMode ? '#fff' : colorSchemes.MiddlePaneBackground, borderRadius: "8px" }}>

                      <div style={{ position: "absolute", marginTop: "-61px", background: !mobileView ? '#fff' : mobileView && isLightMode ? '#fff' : colorSchemes.MiddlePaneBackground, padding: "0px 5px", fontSize: "14px", color: !mobileView ? "#828B94" : mobileView && isLightMode ? "#828B94" : colorSchemes.FontColor }}>Search</div>
                      <input
                        className='shareDialogInput'
                        style={{ background: !mobileView ? '#fff' : mobileView && isLightMode ? '#fff' : colorSchemes.MiddlePaneBackground, color: !mobileView ? '#172D46' : mobileView && isLightMode ? '#172D46' : colorSchemes.FontColor }}
                        type='text'
                        name='name'
                        placeholder='Type To search'
                        autoComplete='off'
                        onChange={(e) => {
                          setaudioUrl('')
                          setTextToSpechInputValue(e.target.value)

                        }}
                      />
                    </div>
                  </div>
                }





                {/*   for mp3file */}
                {/* <div className='mic'  onClick={()=>{audioInputRef.current.click();}}>
                <img style={{ width:isLightMode?28:18, cursor: 'pointer' }} src={Attachment} alt="" />
                </div> 
                <div style={{ display: 'none' }}>
                  <input ref={audioInputRef}
                    type="file"
                    accept="audio/*" onChange={selectMP3File}
                  />
                </div>
                 */}

              </div>
              {aiType == "speachtotext" &&
                <>
                  {listening && isListening
                    ? <h6 className="font-sans font-semibold text-2xl animate-pulse duration-700" style={{ textAlign: "center", marginTop: "20px" }}>Listening...
                      {/* <span className='stopButton' onClick={toggleListen}>Stop Listen</span> */}
                    </h6>
                    : <><h4 className="font-sans font-semibold text-2xl" style={{ textAlign: "center", marginTop: "20px" }}>
                    </h4>
                    </>
                  }
                  {transcription != '' && <div className='queDiv'> <p className="quePara" style={{ textAlign: "center", marginTop: "20px" }}>{transcription}</p>
                  </div>}
                  {transcript != '' && <div className='queDiv'> <p className="quePara" style={{ textAlign: "center", marginTop: "20px" }}>{transcript}</p>
                  </div>}

                </>
              }

              {loading &&
                <div style={{ height: 125, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 8 }}>
                  {isLightMode == 1 ?
                    <img className="loading-spinner" style={{ width: 40, height: 40 }} src={AuthLoader} alt="" />
                    :
                    <img className="loading-spinner" style={{ width: 40, height: 40 }} src={AuthLoader} alt="" />
                  }
                  <div style={{ fontSize: 16, fontWeight: 600, color: "#000" }}>Processing your request...</div>
                </div>
              }
              {data != '' && aiType == "speachtotext" && <div style={{ maxHeight: 200, overflow: "auto", padding: "20px" }}><pre className="font-sans font-semibold text-2xl animate-pulse duration-700" style={{ textAlign: "left", whiteSpace: "pre-wrap" }}>
                {data}</pre>
              </div>}


              {aiType == "texttospeach" && audioUrl != '' &&
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                  <div onClick={() => { play() }} style={{ padding: 10 }}><img style={{ width: 28 , cursor: 'pointer' }} src={PlayAudio} alt="" /></div>
                  <div onClick={() => { downlaod() }} style={{ padding: 10 }}>
                  <img style={{ width: 28 , cursor: 'pointer' }} src={DownloadAudio} alt="" />
                  </div>
                </div>
              }
              <div className='shareDialogInviteBtn' style={{ display: 'flex', marginTop: mobileView ? 0 : 25, justifyContent: 'space-between', marginBottom: mobileView ? 28 : 28, padding: "0px 15px" }}>
                <button
                  style={{
                    background: '#fff' /* colorSchemes.MainBackGroundColor */,
                    color: "#3068C8",
                    border: '0.1px solid #3068C8',
                  }}
                  onClick={() => {
                    setLoading(false);
                    if (aiType == "speachtotext") {
                      setTranscription('');
                      setData('')
                      resetTranscript();
                      SpeechRecognition.stopListening();
                    }
                    else if (aiType == "texttospeach") {
                      setTextToSpechInputValue('');
                      setaudioUrl('')
                      //setData('')
                    }
                  }
                  }
                >
                  Clear
                </button>
                <button
                  style={{ background: '#3068C8', color: '#fff', opacity: aiType == "speachtotext" ? textToSpechInputValue != '' ? 1 : .5 : textToSpechInputValue != '' ? 1 : .5 }}
                  onClick={() => {
                    if (aiType == "speachtotext" && textToSpechInputValue != '') {
                      setLoading(true);
                      fetchGPTTextSearch().then(handleSpeechToText);

                    }
                    else if (aiType == "texttospeach" && textToSpechInputValue != '') {
                      setLoading(true);
                      textToSpeach1()
                      // fetchGPTTextToSpeach().then(handleTextToSpeech).then(playAudio)
                      //fetchGPTTextToSpeach().then(handleTextToSpeech).then(saveAudio).then(playAudio1)
                    }
                  }}
                >
                  Search
                </button>

              </div>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
              </div>


<div style={{display:'none'}} id="audioDownloadDiv"></div>
            </div>

            {/* {transcription !='' && <span className='stopButton'  onClick={() => {
            setTranscription('');
            resetTranscript();
    SpeechRecognition.stopListening();
    }}>Clear</span>} */}

          </div>
        </ClickAwayListener>
      </Dialog>
    </div>
  );
}

export default AIDialog;
